import arrowLeftSwiper from "../../public/images/arrow-left-swiper.svg"
import arrowOutside from "../../public/images/arrow-outside.svg"
import arrowRightSwiper from "../../public/images/arrow-right-swiper.svg"
import arrowIcon from "../../public/images/arrow.png"
import authorIcon from "../../public/images/author.svg"
import defaultAvatar from "../../public/images/avatar-default.svg"
import bgLatestNews from "../../public/images/bg-latest-news.svg"
import brandCareer from "../../public/images/brand-career.svg"
import closeIcon from "../../public/images/close-icon.svg"
import editIcon from "../../public/images/edit-pencil.svg"
import imgEmpty from "../../public/images/empty-img.jpg"
import facebookIcon from "../../public/images/facebook-icon.svg"
import facebookSidebarIcon from "../../public/images/facebook-sidebar.webp"
import homepageGrayIcon from "../../public/images/homepage-gray-icon.svg"
import homepageRedIcon from "../../public/images/homepage-red-icon.svg"
import hotNewsGrayIcon from "../../public/images/hot-news-gray-icon.svg"
import hotNewsRedIcon from "../../public/images/hot-news-red-icon.svg"
import iconCalendarCareer from "../../public/images/icon-calendar-career.svg"
import iconCart from "../../public/images/icon-cart.svg"
import iconJobCareer from "../../public/images/icon-job-career.svg"
import iconLocationCareer from "../../public/images/icon-location-career.svg"
import iconEmail from "../../public/images/icon-mail.svg"
import iconPhone from "../../public/images/icon-phone.svg"
import quoteIcon from "../../public/images/icon-Quote.png"
import iconSalaryCareer from "../../public/images/icon-salary-career.svg"
import imageEmpty from "../../public/images/image-empty.png"
import iconLangVi from "../../public/images/lang-tdg-vn.webp"
import iconLocationStore from "../../public/images/location.webp"
import logoCs from "../../public/images/logo-cs.webp"
import logoEn from "../../public/images/logo-en.png"
import logoTamdaCMS from "../../public/images/logo-tamdacms.png"
import logoTamdaGroupMobile from "../../public/images/logo-tdg-mobile.svg"
import logoTamdaGroup from "../../public/images/logo-tdg.png"
import logoVi from "../../public/images/logo-vi.png"
import logocms from "../../public/images/logocms.webp"
import menuIcon from "../../public/images/menu-icon.svg"
import phoneIcon from "../../public/images/phone-icon.svg"
import playIconWhite from "../../public/images/play-icon.svg"
import tamdaSearchIcon from "../../public/images/search-icon.svg"
import { default as subLogo, default as subMenuLogo } from "../../public/images/sub-menu-logo.svg"
import logoTamdaMedia from "../../public/images/tamda-media-logo.png"
import tamdaWing from "../../public/images/tamda-wing.svg"
import twitterIcon from "../../public/images/twitter_icon.png"
import videoGrayIcon from "../../public/images/video-gray-icon.svg"
import videoRedIcon from "../../public/images/video-red-icon.svg"
import widgetsCard from "../../public/images/widgets-card.webp"
import widgetsRegisterMail from "../../public/images/widgets-register-mail.webp"
import youtubeIcon from "../../public/images/youtube-icon.svg"
import playIcon from "../../public/images/youtube-logo.webp"
import youtubeSidebarIcon from "../../public/images/youtube-sidebar.webp"
import youtubeIconHeader from "../../public/images/youtube.png"


export const Images = {
  logoTamdaCMS,
  brandCareer,
  iconLocationCareer,
  iconSalaryCareer,
  iconCalendarCareer,
  iconJobCareer,
  quoteIcon,
  imgEmpty,
  defaultAvatar,
  logocms,
  logoEn,
  logoVi,
  logoCs,
  arrowOutside,
  imageEmpty,
  logoTamdaMedia,
  tamdaSearchIcon,
  phoneIcon,
  facebookIcon,
  youtubeIcon,
  menuIcon,
  closeIcon,
  homepageRedIcon,
  hotNewsGrayIcon,
  hotNewsRedIcon,
  videoGrayIcon,
  videoRedIcon,
  subMenuLogo,
  playIcon,
  playIconWhite,
  widgetsRegisterMail,
  widgetsCard,
  subLogo,
  twitterIcon,
  homepageGrayIcon,
  authorIcon,
  youtubeIconHeader,
  facebookSidebarIcon,
  youtubeSidebarIcon,
  editIcon,
  logoTamdaGroup,
  iconLangVi,
  logoTamdaGroupMobile,
  iconPhone,
  iconEmail,
  tamdaWing,
  arrowLeftSwiper,
  arrowRightSwiper,
  bgLatestNews,
  iconCart,
  arrowIcon,
  iconLocationStore,
}
